import { USER_LOGGED_OUT } from '../../Types/UserLoggedOut';

export const onLogOut = () => ({
  type: USER_LOGGED_OUT,
});
